import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {HelpersService} from '../helpers/helpers.service';
import { AuthService } from './auth.service';

@Injectable()
export class AuthenticationGuard implements CanActivate {

  constructor(private router: Router,
              private auth: AuthService,
              private helpers: HelpersService) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const result = this.auth.isAuthenticated(true, state.url);
    // this.helpers.logger.info('canActivate:', route, result);
    return result;
    // return true;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/core/authentication/authentication.guard.ts